import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import { showToast } from '@nxsys/utils/toast';
import {
  IconAttachmentPDF,
  IconAttachmentDOC,
  IconAttachmentCSV,
  IconAttachmentTXT,
  IconAttachmentXLS,
  IconAttachmentXLSX,
  IconAttachmentPPT,
  IconAttachmentZIP,
  IconAttachmentIMAGE,
  IconAttachmentOthers,
} from '@nxsys/assets/icons';
import Icon from '@nxsys/components/AppIconImage';

export const getFileExtension = (filename: string) => {
  const nameArray = filename.split('.').reverse();

  return filename ? nameArray[0] : '';
};

export const downloadPdf = (
  noDownload = false,
  elementName = 'pdfdiv',
  fileName = 'Invoice.pdf',
) => {
  const input = document.getElementById(elementName);
  const result = html2canvas(input as HTMLElement, {
    allowTaint: true,
    useCORS: true,
  }).then((canvas) => {
    const doc = new JsPDF('p', 'mm', 'a4');
    const imgWidth = 200;
    const pageHeight = 290;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 5;

    const img = canvas.toDataURL('image/jpeg');

    doc.addImage(img, 'JPEG', 3, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(img, 'JPEG', 3, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    if (!noDownload) doc.save(fileName);
    return doc.output('blob');
  });

  return result;
};
export const downloadFile = (fileUrl: string) => {
  const url = fileUrl;
  const e = document.createElement('a');
  e.href = url;
  e.target = '_blank';
  e.download = url.substr(url.lastIndexOf('/') + 1);
  document.body.appendChild(e);
  e.click();
  document.body.removeChild(e);
};

export const showFileValidation = (file: any) => {
  if (file) return true;
  showToast({
    type: 'warning',
    message: 'Please select a valid file.',
  });
};

export const formatFileTypeToIcon = (type: string) => {
  switch (type) {
    case 'application/pdf':
      return <Icon src={IconAttachmentPDF} alt="pdf" />;
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return <Icon src={IconAttachmentDOC} alt="doc" />;
    case 'text/csv':
    case 'application/csv':
      return <Icon src={IconAttachmentCSV} alt="csv" />;
    case 'text/plain':
      return <Icon src={IconAttachmentTXT} alt="txt" />;
    case 'application/vnd.ms-excel':
      return <Icon src={IconAttachmentXLS} alt="xls" />;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return <Icon src={IconAttachmentXLSX} alt="xlsx" />;
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return <Icon src={IconAttachmentPPT} alt="ppt" />;
    case 'application/zip':
    case 'application/x-zip-compressed':
      return <Icon src={IconAttachmentZIP} alt="zip" />;
    default:
      if (type.includes('image')) {
        return <Icon src={IconAttachmentIMAGE} alt="image" />;
      }
      if (type.includes('excel')) {
        return <Icon src={IconAttachmentXLS} alt="xls" />;
      }
      return <Icon src={IconAttachmentOthers} alt="other" />;
  }
};

export const getFileIconByExtension = (extension: string) => {
  switch (extension) {
    case 'pdf':
      return <Icon src={IconAttachmentPDF} alt="pdf" />;
    case 'doc':
      return <Icon src={IconAttachmentDOC} alt="doc" />;
    case 'xls':
      return <Icon src={IconAttachmentXLS} alt="xls" />;
    case 'xlsx':
      return <Icon src={IconAttachmentXLSX} alt="xlsx" />;
    case 'csv':
      return <Icon src={IconAttachmentCSV} alt="csv" />;
    case 'ppt':
    case 'pptx':
      return <Icon src={IconAttachmentPPT} alt="ppt" />;
    case 'zip':
      return <Icon src={IconAttachmentZIP} alt="zip" />;
    case 'txt':
      return <Icon src={IconAttachmentTXT} alt="txt" />;
    case 'image':
      return <Icon src={IconAttachmentIMAGE} alt="image" />;
    default:
      return <Icon src={IconAttachmentOthers} alt="other" />;
  }
};

export const truncateFileUrl = (fileUrl: string, maxLength: number = 20) => {
  const _fileUrl = fileUrl.replace('https://', '').replace('http://', '');
  if (_fileUrl.length > maxLength) {
    return _fileUrl.slice(0, maxLength) + '...' + _fileUrl.slice(-maxLength);
  }
  return _fileUrl;
};
